
import { PLATFORMS } from '../enums/betslip-constants';
/**
 * Parameters model class for notification messages for betslip
 */
export default class BetslipPlacementParamsModel {
  /**
   * Class constructor method
   * @param userId
   * @param provider
   * @param tenantId
   * @param languageId
   *  @param platform
   */
  constructor({
    userId = APP_SETTINGS.player.id,
    provider = +APP_SETTINGS.settings.userProviderId || 0,
    tenantId = APP_SETTINGS.tenant,
    languageId = window.btoLangId,
    platform = process.env.VUE_APP_IS_AGENT ? PLATFORMS.ONLINE_SHOP : PLATFORMS.WEB,
  }) {
    /**
     * Logged in user ID
     * @type {number}
     */
    this.userId = userId;
    /**
     *
     * @type {number}
     */
    this.provider = provider;
    /**
     * Tenant ID
     * @type {number}
     */
    this.tenantId = tenantId;
    /**
     *
     * @type {number}
     */
    this.languageId = languageId;
    /**
     *
     * @type {number}
     */
    this.platform = platform;
  }

  /**
   * Load parameters as array
   * @returns {*[]}
   */
  loadParams() {
    return [
      this.userId,
      this.provider,
      this.tenantId,
      this.languageId,
      this.platform,
    ];
  }
}
